import React, { FC } from 'react';

import { InfoCard } from '@eika/card';

import { EiendomType, SoeknadContainerWeb, SoeknadstypeWeb } from '../../generated-types';
import { useTranslation } from '../../translations';
import Soeknadsbeloep from './soeknadsbeloep';
import Soeknadsdetaljer from './soeknadsdetaljer';

import husMSkyer from '../../resources/hus-m-skyer.svg';

interface Props {
    soeknadContainer: SoeknadContainerWeb | undefined;
}

const OppsummeringHeader: FC<Props> = ({ soeknadContainer }) => {
    const { oppsummering } = useTranslation();
    const soeknadstype = soeknadContainer?.soeknad?.soeknadtype;
    const harMedlaantaker = (soeknadContainer && soeknadContainer?.laantaker.length > 1) || false;
    const eiendomType =
        soeknadContainer?.soeknad?.soeknadtype === SoeknadstypeWeb.KJOEPE_BOLIG ? EiendomType.BUYING : null;
    const eiendom = soeknadContainer?.eiendom.find((e) => e.type === eiendomType);

    return (
        <div className="sgw-layout margin-top-extra-large">
            <section className="sgw-layout-item sgw-layout-item__full-width">
                <InfoCard asHeader img={<img src={husMSkyer} alt="Hus med skyer" />}>
                    <InfoCard.TitleH1>{oppsummering.title}</InfoCard.TitleH1>
                    {soeknadstype === SoeknadstypeWeb.KJOEPE_BOLIG && (
                        <p>{`${harMedlaantaker ? oppsummering.infoDereSoekerOm : oppsummering.infoDuSoekerOm} ${
                            oppsummering.infoKjoepBolig
                        } ${eiendom?.adresse}, ${eiendom?.postnummer} ${eiendom?.poststed}`}</p>
                    )}
                    {soeknadstype === SoeknadstypeWeb.FINANSIERINGSBEVIS && (
                        <p>{`${harMedlaantaker ? oppsummering.infoDereSoekerOm : oppsummering.infoDuSoekerOm} ${
                            oppsummering.infoFinansieringsbevis
                        }`}</p>
                    )}
                    {(soeknadstype === SoeknadstypeWeb.REFINANSIERE_BOLIGLAAN ||
                        soeknadstype === SoeknadstypeWeb.FLYTTE_BOLIGLAAN ||
                        soeknadstype === SoeknadstypeWeb.NYTT_BOLIGLAAN) &&
                        soeknadContainer?.soeknad && (
                            <>
                                <p className="margin-bottom-medium">{`${eiendom?.adresse}, ${eiendom?.postnummer} ${eiendom?.poststed}`}</p>
                                <Soeknadsdetaljer soeknad={soeknadContainer?.soeknad} />
                                <Soeknadsbeloep soeknad={soeknadContainer?.soeknad} harMedlaantaker={harMedlaantaker} />
                            </>
                        )}
                </InfoCard>
            </section>
        </div>
    );
};

export default OppsummeringHeader;
